import { Component, Input } from "@angular/core";
import { MagicSet } from "@apiserver-rest/ponder-data-client-base";
import { MagicSetIconComponent } from "./magic-set-icon.component";
import { ItemInfoComponent } from "@ponder-shared/components/item-info.component";
import { MagicSetDecksComponent } from "./magic-set-decks.component";
import { FormatDatePipe } from "@ponder-shared/pipes/format-date.pipe";
import { NavigationService } from "@ponder-core/navigation/navigation.service";

@Component({
    selector: "magic-set-info",
    imports: [MagicSetIconComponent, MagicSetDecksComponent, FormatDatePipe],
    templateUrl: "./magic-set-info.component.html"
})
export class MagicSetInfoComponent extends ItemInfoComponent {
    @Input({ required: true }) magicSet!: MagicSet;
    @Input() childSets?: MagicSet[];

    public allSelectedSets: string[] = [];
    private setFilter?: string;

    public constructor(private navigation: NavigationService) {
        super();
    }

    public ngOnInit() {
        this.childSets?.sort((a: MagicSet, b: MagicSet) => {
            var dateSort = b.releaseDate.getTime() - a.releaseDate.getTime();

            if (dateSort == 0) {
                return a.name!.localeCompare(b.name!);
            } else {
                return dateSort;
            }
        });
    }

    public onSetSelected(code: string): void {
        var index = this.allSelectedSets.indexOf(code);

        if (index >= 0) {
            this.allSelectedSets.splice(index, 1);
        } else {
            this.allSelectedSets.push(code);
        }
    }

    public onViewSelectedSets(): void {
        if (this.allSelectedSets.length == 0) {
            return;
        } else if (this.allSelectedSets.length == 1) {
            this.navigation.goto(`/magic/set/${this.allSelectedSets[0]}`);
        }
         else {
            this.navigation.goto("/search", { game: "Magic", set: this.allSelectedSets.join(',').toLowerCase() });
         }
    }

    public onFilterUpdated(value: string | undefined): void {
        this.setFilter = value?.toLowerCase();
    }

    public isFiltered(set: MagicSet): boolean { 
        if (this.setFilter?.length) {
            if (set.name!.toLowerCase().indexOf(this.setFilter) < 0) {
                return true;
            }
        }

        if (set.cardCount == undefined || set.cardCount == 0) {
            return true;
        }

        return false;
    }
}